import { render, staticRenderFns } from "./AgetnCenterButton.vue?vue&type=template&id=635dd30b&scoped=true"
import script from "./AgetnCenterButton.vue?vue&type=script&lang=js"
export * from "./AgetnCenterButton.vue?vue&type=script&lang=js"
import style0 from "./AgetnCenterButton.vue?vue&type=style&index=0&id=635dd30b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635dd30b",
  null
  
)

export default component.exports